import { create } from 'zustand';

import { VideoTab } from '@/shared/ui/VideoPlayer/views/ProjectVideoPlayer/types';

type PlayerStore = {
  activeTextTrack: 'dst' | 'src';
  activeVideoTab: null | VideoTab;
  canPlay: boolean;
  currentTimeSec: number;
  isPlaying: boolean;
};

const initialState: PlayerStore = {
  activeTextTrack: 'src',
  activeVideoTab: null,
  canPlay: false,
  currentTimeSec: 0,
  isPlaying: false,
};

export const usePlayerStore = create<PlayerStore>(() => ({
  ...initialState,
}));

export const setPlayerCanPlay = (canPlay: PlayerStore['canPlay']) => usePlayerStore.setState({ canPlay });
export const setPlayerCurrentTime = (currentTimeSec: number) => usePlayerStore.setState({ currentTimeSec });
export const setPlayerIsPlaying = (isPlaying: boolean) => usePlayerStore.setState({ isPlaying });
export const setPlayerVideoTab = (activeVideoTab: VideoTab) =>
  usePlayerStore.setState({ activeTextTrack: activeVideoTab === VideoTab.SrcVideo ? 'src' : 'dst', activeVideoTab });
export const resetPlayerStore = () => usePlayerStore.setState({ ...initialState });
